(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientAgreementsSendDialogController', PatientAgreementsSendDialogController);

    PatientAgreementsSendDialogController.$inject = ['$stateParams', '$state', 'ipmConstants', '$uibModalInstance', 'PatientAgreementsService', 'patientId', '$translate', 'AlertService'];

    function PatientAgreementsSendDialogController($stateParams, $state, constants, $uibModalInstance, PatientAgreementsService, patientId, $translate , AlertService) {
        var vm = this;
        vm.patientId = patientId;
        vm.agreements = null;
        vm.agreementSeleted = null;
        vm.isSaving = false;
        vm.isInvalidAgreement = false;
        vm.clear = clear;
        vm.save = save;
        vm.selectAgreementOnChange = selectAgreementOnChange;

        init();

        function init() {
            getAllAgreement();
        }

        function getAllAgreement() {
            vm.isLoading = true;
            PatientAgreementsService.getAllAgreementForSelect(vm.patientId, constants.SEND_NEW_AGREEMENT).then(function (response) {
                vm.agreements = response ? response : [];
                if (vm.agreements.length > 0) {
                    vm.agreements.forEach(function (value) {
                        value.nameText = value.name
                            ? $translate.instant('ipmApp.agreements.workflowName.' + value.name)
                            : '';
                    });
                }
                vm.isLoading = false;
            });
        }

        function selectAgreementOnChange() {
            if (!vm.agreementSeleted || vm.agreementSeleted.existedAndAllCompleted === true) {
                vm.isInvalidAgreement = true;
            } else {
                vm.isInvalidAgreement = false;
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.isSaving || !vm.agreementSeleted || !vm.patientId) {
                return;
            }
            vm.isSaving = true;
            PatientAgreementsService.saveAgreement(vm.patientId, vm.agreementSeleted).then(function (res) {
                onSaveSuccess(res);
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.status !== 200) {
                console.error("save Patient Agreement Error: ", error);
                AlertService.error("An error occurred while updating the agreement. Please try again");
                $uibModalInstance.dismiss(error);
            }
        }
    }
})();
